import { render, staticRenderFns } from "./sorunlufistarihleriduzenle.vue?vue&type=template&id=112a123a&"
import script from "./sorunlufistarihleriduzenle.vue?vue&type=script&lang=js&"
export * from "./sorunlufistarihleriduzenle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports